import { Component, OnInit } from '@angular/core';
import { LoginService } from '../security/login.service';
import { FaviconService } from '../favicon.service';
import { HttpService } from '../service/http.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SearchOperator } from '../search-operator';
import { SearchAction } from '../search-action';
import { SearchColumn } from '../search-column';
import { SearchRule } from '../search-rule';
import { SavedSearch } from '../saved-search';
import * as moment from 'moment';
import { ToastMessageService } from '../toast-message.service';
import { SimpleBrugesVndBooking } from '../simple-bruges-vnd-booking';

@Component({
  selector: 'app-bookings-current',
  templateUrl: './bookings-current.component.html',
  styleUrls: ['./bookings-current.component.css']
})
export class BookingsCurrentComponent implements OnInit {

  bookings: SimpleBrugesVndBooking[] = [];
  bookingsRaw: SimpleBrugesVndBooking[] = [];
  bookingsView: SimpleBrugesVndBooking[] = [];
  recordNumber = 0;
  filteredBookings!: SimpleBrugesVndBooking[];

  first: number = 0;
  pdfUrl!: string;

  reportDownloadUrl!: SafeResourceUrl;

  searchForm!: FormGroup;

  customSearchForm!: FormGroup;
  searchOperators: SearchOperator[] = [];
  searchActions: SearchAction[] = [];
  searchColumns: SearchColumn[] = [];
  searchRules: SearchRule[] = [];
  savedSearchForm!: FormGroup;
  savedSearchList: SavedSearch[] = [];
  savedSearchEditForms: FormGroup[] = [];
  
  isSavedSearchesVisible = false;

  dateSearchForm!: FormGroup;
  bookingsLoading = false;

  constructor(
    private loginService: LoginService,
    private faviconService: FaviconService,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.faviconService.sbms();
   }

  ngOnInit() {
    this.httpService.getCurrentBookingsWithVademecum().subscribe(res => {
      this.filteredBookings = res;
      this.bookings = res;
            this.bookingsRaw = res;
      this.bookingsView = res.slice(0, 49);
      this.recordNumber = res.length;
      this.bookingsLoading = false;
    }, error => {
            this.toastService.addError("Error", error.message);
      this.bookingsLoading = false;
    });
    this.dateSearchForm = this.builder.group({
      startDate: moment().toDate(),
      endDate: moment().toDate()
    });
    // this.filter = this.searchForm.get("searchTerm")!.valueChanges.pipe(startWith(""));
    this.initFilter();
  }

  searchBoxChange(event: any){
    const value = (event.target as HTMLInputElement).value.toLowerCase();
    this.bookingsView = this.bookingsRaw.filter(booking => {
      return booking.firstName.toLowerCase().includes(value) || booking.lastName.toLowerCase().includes(value);
    });
  }

  resetSearch(){
    this.bookingsLoading = true;
    this.httpService.getActiveBookingsWithVademecumAndPicture().subscribe(res => {
      this.filteredBookings = res;
            this.bookingsRaw = res;
      this.bookingsView = res.slice(0, 49);
      this.recordNumber = res.length;
      this.bookingsLoading = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.bookingsLoading = false;
    });
    // this.bookings = this.httpService.getActiveBookingsWithVademecumAndPicture();
    // this.bookings.subscribe(bookings => {
    //   this.bookingsRaw = bookings;
    //   this.bookingsView = bookings.slice(0, 49);
    //   this.recordNumber = bookings.length;
    //   this.bookingsLoading = false;
    //   this.bookingsLoading = false;
    // }, error => {
    //   this.toastService.addError("Error", error.message);
    //   this.bookingsLoading = false;
    // });
  }

  searchBookingsByDates(){
    if(this.dateSearchForm.value.startDate && this.dateSearchForm.value.endDate){
      let startDateStr = moment(this.dateSearchForm.value.startDate).format("YYYY-MM-DD");
      let endDateStr = moment(this.dateSearchForm.value.endDate).format("YYYY-MM-DD");
      this.bookingsLoading = true;
      this.httpService.getActiveBookingsWithVademecumAndPictureByDates(startDateStr, endDateStr).subscribe(res => {
        this.bookings = res;
        this.filteredBookings = res;
        this.bookingsRaw = this.bookings;
                this.bookingsView = res.slice(0, 49);
        this.recordNumber = res.length;
                this.bookingsLoading = false;
      }, error => {
                this.toastService.addError("Error", error.message);
        this.bookingsLoading = false;
      });

    }
  }

  sortByStartDate(isDsc: boolean){
    let modeNumber = 1;
    if(isDsc == false){
      modeNumber = -1;
    }
    this.filteredBookings.sort((a, b) => {
        if(a.startDate.isAfter(b.startDate)){
          return -1 * modeNumber;
        }
        else {
          return 1 * modeNumber;
        }
      });
            this.bookingsView = this.filteredBookings.slice(0,49);
      this.recordNumber = this.filteredBookings.length;
    // this.bookings.subscribe(bookings => {
    //   bookings.sort((a, b) => {
    //     if(a.startDate.isAfter(b.startDate)){
    //       return -1 * modeNumber;
    //     }
    //     else {
    //       return 1 * modeNumber;
    //     }
    //   });
    //   this.bookingsRaw = bookings;
    //   this.bookingsView = bookings.slice(0,49);
    //   this.recordNumber = bookings.length;
    // });
  }

  initFilter(){
    // this.filteredBookings = combineLatest([this.bookings, this.filter]).pipe(
    //   map(([bookings, filterString]) => bookings.filter(booking => 
    //     (booking.firstName.toLowerCase().indexOf(filterString.toLowerCase()) != -1) || 
    //     (booking.lastName.toLowerCase().indexOf(filterString.toLowerCase()) != -1)
    //   )));
  }

  downloadPdf(booking: SimpleBrugesVndBooking) {
    booking.downloadingPdf = true;
    this.httpService.getPdfBlob(booking.id, booking.language.name).subscribe(blob => {
      this.pdfUrl = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = this.pdfUrl;
      link.download = "Vademecum " + booking.lastName + " " + booking.firstName + ".pdf";
      link.click();
      booking.downloadingPdf = false;
    });
  }

  updateView(event: any){
    this.bookingsView = this.bookingsRaw.slice(event.first, event.first + event.rows - 1);
  }
}
